import Vue, { VNode, PropType } from 'vue';
import { BranchLinkOptions } from './branchLinkConfiguration';
import { Nullable } from '@/scripts/models/utility-types';
import { createLinkSync } from './branch-link/creator';
import { startTrackerTimer, PerformanceTracker } from './performance-tracker';

interface ComponentData {
  link: Nullable<string>;
  pendingExecutionMethod: Nullable<CallableFunction>;
  timeout: Nullable<number>;
  performanceTracker: Nullable<PerformanceTracker>;
}

const getFallbackLink = (): string => '/mobile';

export default Vue.extend({
  props: {
    dataBranch: {
      type: Object as PropType<BranchLinkOptions>,
      default: (): {} => ({}),
    },
    branchLinkExecutionTimeout: {
      type: Number,
      default: 5000,
    },
  },

  data(): ComponentData {
    return {
      link: null,
      pendingExecutionMethod: null,
      timeout: null,
      performanceTracker: null,
    };
  },

  watch: {
    dataBranch: {
      immediate: true,
      handler(): void {
        this.initializeButton();
      },
    },
  },

  methods: {
    clickButton(): void {
      if (this.pendingExecutionMethod) {
        return;
      }

      if (this.link) {
        this.openLink();
        return;
      }

      this.pendingExecutionMethod = this.openLink;
      this.timeout = window.setTimeout(() => {
        this.resetState();
        this.openLink();
      }, this.branchLinkExecutionTimeout);
    },

    openLink(): void {
      const linkToOpen = (this.link != null) ? this.link : getFallbackLink();

      window.open(linkToOpen);
      this.performanceTracker && this.performanceTracker.trackLinkOpen(linkToOpen, this.dataBranch);
    },

    initializeButton(): void {
      this.resetState();
      this.performanceTracker = startTrackerTimer();

      this.link = createLinkSync(this.dataBranch);
      this.performanceTracker && this.performanceTracker.trackGenerationDone();

      if (this.pendingExecutionMethod) {
        this.pendingExecutionMethod();
        this.pendingExecutionMethod = null;

        this.clearFallbackTimeout();
      }
    },

    clearFallbackTimeout(): void {
      clearTimeout(this.timeout as number);
      this.timeout = null;
    },

    resetState(): void {
      // Reset state
      this.link = null;
      this.pendingExecutionMethod = null;

      this.clearFallbackTimeout();
    },
  },
  render(h): VNode {
    const defaultScopedSLotRenderFn = this.$scopedSlots.default;
    const child = defaultScopedSLotRenderFn
      ? defaultScopedSLotRenderFn({})
      : h('button', ['Open in App'])
    ;

    return h(
      'div',
      {
        on: {
          click: this.clickButton,
        },
      },
      [child],
    );
  },
});
